<template>
  <div>
    <form @submit.prevent="saveMenuItemLimit">
      <b-modal
        id="showModal"
        v-model="showModal"
        size="m"
        no-close-on-backdrop
        no-close-on-esc
        @shown="reset"
      >
        <div slot="modal-header" class="w-100">
          <font-awesome-icon icon="bars" />
          <span class="pl-2">
            {{ input ? 'Edit' : 'Add' }} Menu Item Limit
          </span>
        </div>
        <div>
          <b-container fluid class="pt-4">
            <b-row v-if="!input" class="mt-2">
              <b-col md="4">
                <label>Outlet Code</label>
              </b-col>
              <b-col md="8" :class="{'form-error': errors.first('outletCode')}">
                <b-form-input
                  v-model="obj.outletCode"
                  v-validate="'required|alpha_num'"
                  type="text"
                  name="outletCode"
                />
                <small>{{ errors.first('outletCode') }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="4">
                <label>Menu Item Code</label>
              </b-col>
              <b-col md="8" :class="{'form-error': errors.first('menuItemCode')}">
                <b-form-input
                  v-model="obj.asset_id"
                  v-validate="'required|alpha_num'"
                  type="text"
                  name="menuItemCode"
                  :disabled="input ? true : false"
                />
                <small>{{ errors.first('menuItemCode') }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="4">
                <label>Order Type</label>
              </b-col>
              <b-col md="8" :class="{'form-error': errors.first('orderType')}">
                <b-form-input
                  v-model="obj.value"
                  v-validate="'required|alpha_num'"
                  type="text"
                  name="orderType"
                />
                <small>{{ errors.first('orderType') }}</small>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-btn type="submit" variant="success">
            <font-awesome-icon icon="save" />
            {{ input ? 'Update' : 'Save' }} Data
          </b-btn>
          <b-btn class="float-right" variant="danger" @click="discardModal">
            <font-awesome-icon icon="times" />Discard
          </b-btn>
        </div>
      </b-modal>
    </form>
  </div>
</template>

<script>
import { getResponseToMTHForNewPort } from '@/utils/helpers';
import constants from '@/utils/constants';

export default {
  props: {
    input: {
      type: null,
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      obj: {},
      updatePayloadObj: {
        asset_id: null,
        new_value: null,
        old_value: null
      }
    };
  },

  mounted() {
    if (this.input) {
      this.updatePayloadObj.asset_id = this.input.asset_id;
      this.updatePayloadObj.old_value = this.input.value;
    }
  },

  methods: {
    // add and update records
    saveMenuItemLimit() {
      this.$validator.validate().then(valid => {
        if (valid) {
          if (this.input === null) {
            this.$store
              .dispatch('CreateLimitForNewInterface', this.obj)
              .then(response => {
                let res = getResponseToMTHForNewPort(
                  response,
                  this.$swal,
                  constants.RECORD_IS_CREATED
                );
                if (res) {
                  this.$emit('discard-modal', true);
                  this.reset();
                }
              })
              .catch(error => {
                this.$swal(
                  constants.SOMETHING_WROING,
                  error.response.data.message,
                  constants.STATUS_ERROR
                );
              });
          } else {
            this.updatePayloadObj.new_value = this.obj.value;
            this.$store
              .dispatch('UpdateLimitForNewInterface', this.updatePayloadObj)
              .then(response => {
                let res = getResponseToMTHForNewPort(
                  response,
                  this.$swal,
                  constants.RECORD_IS_UPDATED
                );
                if (res) {
                  this.$emit('discard-modal', true);
                  this.reset();
                }
              })
              .catch(error => {
                this.$swal(
                  constants.SOMETHING_WROING,
                  error.response.data.message,
                  constants.STATUS_ERROR
                );
              });
          }
        }
      });
    },
    discardModal() {
      this.reset();
      this.$emit('discard-modal');
    },

    // reset input fields
    reset() {
      if (this.input == null) {
        this.obj = {
          asset_id: '',
          value: ''
        };
      } else {
        this.obj = this.input;
      }
    }
  }
};
</script>
